import { useState } from 'react'
import toastr from 'toastr'
import ApiChat from '../../../api/ApiChat'

export default function useLeagueLandingChat({ division }) {
  const [isChatOpen, setIsChatOpen] = useState(false)
  const [focusedChannelId, setFocusedChannelId] = useState(null)
  const [chatFocusMode, setChatFocusMode] = useState(false)

  const handleMessageOpponent = async (opponent) => {
    try {
      await ApiChat.joinDivisionChannels()
      const response = await ApiChat.startDirectMessage(
        opponent.id,
        division.division_id,
      )

      if (response?.channel?.id) {
        setFocusedChannelId(response.channel.id)
        setChatFocusMode(true)
        setIsChatOpen(true)
        window.dispatchEvent(new CustomEvent('chat:refresh-channels'))
      }
    } catch (error) {
      toastr.error(error?.message || 'Failed to start chat')
    }
  }

  const handleOpenDivisionChat = async () => {
    try {
      await Promise.all([
        ApiChat.joinDivisionChannels(),
        ApiChat.joinLeagueChannels(),
      ])

      setFocusedChannelId(null)
      setChatFocusMode(false)
      setIsChatOpen(true)
      window.dispatchEvent(new CustomEvent('chat:refresh-channels'))
    } catch (error) {
      toastr.error(error?.message || 'Failed to open chat')
    }
  }

  const handleCloseChat = () => {
    setIsChatOpen(false)
    setFocusedChannelId(null)
    setChatFocusMode(false)
  }

  return {
    isChatOpen,
    focusedChannelId,
    chatFocusMode,
    handleMessageOpponent,
    handleOpenDivisionChat,
    handleCloseChat,
  }
}
